




import Vue from 'vue';
import importantInformationCreateSendingData from '@/components/important-information/important-information-create-sending-data.component.vue';

export default Vue.extend({
  components: {
    'important-information-create-sending': importantInformationCreateSendingData,
  },
});
